// extracted by mini-css-extract-plugin
export default {"container":"LinkRow_container__K+d3Q"};